import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="min-h-screen pt-24 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="fade-in-left text-center mb-12">
          <div class="inline-flex items-center gap-2 bg-primary/10 rounded-full px-4 py-2 mb-4">
            <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
            <span class="text-sm font-medium text-primary">گالری</span>
          </div>
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-black mb-4">گالری <span class="text-primary">تصاویر</span></h2>
          <p class="text-muted-foreground max-w-2xl mx-auto">تصاویری از فضای باشگاه، کلاس‌ها، مسابقات و رویدادهای ویژه</p>
        </div>

        <!-- Category Filters -->
        <div class="flex flex-wrap gap-2 justify-center mb-8">
          <button *ngFor="let cat of categories" (click)="selectedCategory = cat.value"
            [ngClass]="selectedCategory === cat.value ? 'bg-primary text-primary-foreground' : 'border border-border hover:bg-accent'"
            class="px-4 py-2 rounded-lg text-sm font-medium transition-colors">{{ cat.label }}</button>
        </div>

        <!-- Gallery Grid -->
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4 stagger-children">
          <div *ngFor="let img of filtered; let i = index"
            class="group cursor-pointer overflow-hidden rounded-xl"
            [ngClass]="{'col-span-2 row-span-2': i === 0 && selectedCategory === 'all'}"
            (click)="openLightbox(img)">
            <div class="relative h-full min-h-[180px] lg:min-h-[200px]">
              <img [src]="img.src" [alt]="img.title" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"/>
              <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div class="absolute bottom-0 right-0 left-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 class="text-white font-bold text-sm">{{ img.title }}</h3>
                <p class="text-gray-300 text-xs mt-1">{{ img.description }}</p>
              </div>
              <div class="absolute top-3 right-3">
                <span class="bg-background/80 backdrop-blur-sm text-foreground text-xs px-2 py-1 rounded">{{ img.categoryLabel }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Lightbox -->
        <div *ngIf="selectedImage" class="fixed inset-0 z-[100] flex items-center justify-center bg-black/95" (click)="closeLightbox()">
          <div class="relative max-w-5xl w-full mx-4">
            <img [src]="selectedImage.src.replace('w=800', 'w=1400')" [alt]="selectedImage.title" class="w-full max-h-[80vh] object-contain"/>
            <div class="absolute bottom-0 right-0 left-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
              <h3 class="text-white font-bold text-lg">{{ selectedImage.title }}</h3>
              <p class="text-gray-300 text-sm mt-1">{{ selectedImage.description }}</p>
            </div>
            <!-- Nav buttons -->
            <button (click)="navigateImage(-1); $event.stopPropagation()" class="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white rounded-full p-2">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
            </button>
            <button (click)="navigateImage(1); $event.stopPropagation()" class="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white rounded-full p-2">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
            </button>
            <!-- Close -->
            <button (click)="closeLightbox()" class="absolute top-4 left-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white rounded-full p-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            <!-- Counter -->
            <div class="absolute top-4 right-4 bg-black/50 backdrop-blur-sm text-white text-sm px-3 py-1 rounded-full">{{ currentIndex + 1 }} / {{ filtered.length }}</div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [':host { display: block; }']
})
export class GalleryComponent {
  selectedCategory = 'all';
  selectedImage: any = null;
  currentIndex = 0;

  categories = [
    { label: 'همه', value: 'all' },
    { label: 'سالن بدنسازی', value: 'gym' },
    { label: 'کلاس های گروهی', value: 'classes' },
    { label: 'مسابقات', value: 'competition' },
    { label: 'رویدادها', value: 'events' },
  ];

  images = [
    { id: 1, src: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80', category: 'gym', categoryLabel: 'سالن', title: 'سالن بدنسازی اصلی', description: 'مجهز به دستگاه‌های ایتالیایی' },
    { id: 2, src: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=800&q=80', category: 'gym', categoryLabel: 'سالن', title: 'ناحیه وزنه آزاد', description: 'فضای باز برای تمرینات قدرتی' },
    { id: 3, src: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80', category: 'classes', categoryLabel: 'کلاس', title: 'کلاس یوگا', description: 'محیطی آرام و دلنشین' },
    { id: 4, src: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80', category: 'classes', categoryLabel: 'کلاس', title: 'کلاس آیروبیک', description: 'انرژی و حرکت' },
    { id: 5, src: 'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&q=80', category: 'competition', categoryLabel: 'مسابقه', title: 'مسابقات کاراته', description: 'قهرمانی ملی' },
    { id: 6, src: 'https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&q=80', category: 'gym', categoryLabel: 'سالن', title: 'ناحیه کاردیو', description: 'تردمیل و دوچرخه ثابت' },
    { id: 7, src: 'https://images.unsplash.com/photo-1599058917765-a780eda07a3e?w=800&q=80', category: 'events', categoryLabel: 'رویداد', title: 'مراسم افتتاحیه', description: 'جشن شروع فصل جدید' },
    { id: 8, src: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80', category: 'classes', categoryLabel: 'کلاس', title: 'کلاس پیلاتس', description: 'تمرینات عضلات مرکزی' },
    { id: 9, src: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?w=800&q=80', category: 'competition', categoryLabel: 'مسابقه', title: 'مسابقات بدنسازی', description: 'کسب مدال طلا' },
    { id: 10, src: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80', category: 'gym', categoryLabel: 'سالن', title: 'منطقه فانکشنال', description: 'تمرینات عملکردی' },
    { id: 11, src: 'https://images.unsplash.com/photo-1579722821273-0f6c7d44362f?w=800&q=80', category: 'events', categoryLabel: 'رویداد', title: 'جشنواره سلامتی', description: 'برنامه‌های سلامتی و تغذیه' },
    { id: 12, src: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&q=80', category: 'classes', categoryLabel: 'کلاس', title: 'کلاس کششی', description: 'تمرینات انعطاف‌پذیری' },
    { id: 13, src: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80', category: 'gym', categoryLabel: 'سالن', title: 'محیط باشگاه', description: 'طراحی مدرن و دلنشین' },
    { id: 14, src: 'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=800&q=80', category: 'competition', categoryLabel: 'مسابقه', title: 'تورنمنت بوکس', description: 'رقابت‌های هیجان‌انگیز' },
    { id: 15, src: 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=800&q=80', category: 'events', categoryLabel: 'رویداد', title: 'سمینار تغذیه', description: 'آموزش تغذیه ورزشی' },
    { id: 16, src: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80', category: 'classes', categoryLabel: 'کلاس', title: 'زومبا پارتی', description: 'رقص و ورزش با هم' },
  ];

  get filtered(): any[] {
    return this.selectedCategory === 'all' ? this.images : this.images.filter(i => i.category === this.selectedCategory);
  }

  openLightbox(img: any): void {
    this.selectedImage = img;
    this.currentIndex = this.filtered.findIndex(i => i.id === img.id);
  }

  closeLightbox(): void { this.selectedImage = null; }

  navigateImage(dir: number): void {
    this.currentIndex = (this.currentIndex + dir + this.filtered.length) % this.filtered.length;
    this.selectedImage = this.filtered[this.currentIndex];
  }
}
